<script setup>
import { ref,watchEffect } from "vue";
import LocalStorage from '@/controller/LocalStorage.js';
const userColor = ref(LocalStorage.getColor());
const props = defineProps({
  value: String,
  name: String,
  placeholder: String,
  type: String,
  error: Boolean,
  fontSize: String,
  disabled: Boolean,
  filled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["changeInput"]);

function onChangeInput(event) {
  const newValue = event.target.value;
  emit("changeInput", newValue, event.target.name);
}
const customValue = ref(props.value);

watchEffect(() => {
  customValue.value = props.value;
});
</script>

<template>
  <input
    class="customInput"
    :class="[props.error ? 'error' : '', props.fontSize ? props.fontSize : '', props.filled ? 'filled' : '']"
    :type="type"
    :placeholder="placeholder"
    :disabled="disabled"
    v-model="customValue"
    :name="props.name"
    :error="props.error"
    @change="onChangeInput($event)"
  />
</template>

<style lang="scss" scoped>
.customInput {
  width: 100%;
  line-height: 1.7 !important;
  border-radius: 0.24rem;
  border: 1px solid #e2e8f0;
  border-radius: 50px;
  background-color: white !important;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.7rem;
  padding-bottom: 0.5rem;
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  transition: border-color 0.3s ease;
  font-size: .875rem;
  font-family: 'CircularStd-Book';
  &.error {
    border: 1px solid #FF9999;
  }
}

.filled{
  border-color: v-bind(userColor);
}

.customInput:focus {
  
  border-color: v-bind(userColor);
}

.customInput:focus-visible {
  outline: none;
  border-color: v-bind(userColor);
}

.customInput:disabled {
  background-color: #f7f7f7;
  color: #808080;
  opacity: 1;
}
.xs {
  font-size: 10px;
}
.sm {
  font-size: 12px;
}
.md {
  font-size: 14px;
}
.lg {
  font-size: 16px;
}
</style>
